//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import VehicleCard from '../../forms/Vehicle/VehicleCard.vue'
import EmployeeCard from '../../forms/Employee/EmployeeCard.vue'
import ProjectCard from '../../forms/Project/ProjectCard.vue'
import StockCard from '../../forms/Stock/StockCard.vue'
import VehicleGroupTypeCard from '../../forms/VehicleGroupType/VehicleGroupTypeCard.vue'
import VehicleProviderCard from '../../forms/VehicleProvider/VehicleProviderCard.vue'
import YandexAccountCard from '../../forms/YandexAccount/YandexAccountCard.vue'

export default {
  name: 'ObjectCardWrapper',
  props: {
    objectId: {
      type: [String, Number],
      default: null
    },
    objectType: {
      type: String,
      default: null
    },
    modeCustom: { // -> local
      type: Boolean,
      default: null
    },
    readonly: { // -> local
      type: Boolean,
      default: false
    },
    closable: { // -> local
      type: Boolean,
      default: true
    },
    cardParams: {
      type: Object,
      default: null
    },
    objectParams: {
      type: Object,
      default: null
    },
    objectData: {
      type: Object,
      default: null
    },
    typeKey: {
      type: String,
      default: null
    },
    subtypeKey: {
      type: String,
      default: null
    },
    headerHidden: { // -> local
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    create: {
      type: Boolean,
      default: false
    },
    createConfig: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      component: null,
      shown: false,
      isWrapperMounted: false,
      isCardMounted: false,
      objectTypeLocal: null,
      modeCustomLocal: false,
      loader: null
    }
  },
  computed: {
    isMounted: function () {
      return !!(this.shown && this.isWrapperMounted && this.isCardMounted)
    }
  },
  watch: {
    objectType: {
      handler: function (objectType, prevObjectType) {
        if (objectType) {
          this.objectTypeLocal = objectType
        } else if (prevObjectType) {
          this.objectTypeLocal = null
        }
      },
      immediate: true
    },
    '$route.path': {
      handler: function (path) {
        if (path && path.startsWith('/object/')) {
          this.$nextTick(() => {
            if (!this.objectType) {
              if (this.objectTypeLocal === this.$route.params.type) {
                this.objectTypeLocal = null // Чтобы сработал watcher objectTypeLocal при переходе в карточку другого объекта того же типа
              }
              this.$nextTick(() => {
                this.objectTypeLocal = this.$route.params.type
              })
            }
          })
        }
      },
      immediate: true
    },
    objectTypeLocal: {
      handler: function (objectType) {
        if (objectType) {
          let loader = null
          this.component = null
          if (this.modeCustom == null || this.modeCustom === true) {
            if (objectType === 'employee') {
              this.component = EmployeeCard
              // loader = () => import('../../forms/Employee/EmployeeCard.vue')
            } else if (objectType === 'vehicle') {
              this.component = VehicleCard
              // loader = () => import('../../forms/Vehicle/VehicleCard.vue')
            } else if (objectType === 'project') {
              this.component = ProjectCard
            } else if (objectType === 'stock') {
              this.component = StockCard
            } else if (objectType === 'vehicleGroupType') {
              this.component = VehicleGroupTypeCard
            } else if (objectType === 'deltaOrganization' && this.subtypeKey === 'vehicleProvider') {
              this.component = VehicleProviderCard
            } else if (objectType === 'yandexAccount') {
              this.component = YandexAccountCard
            } else if (objectType === 'trafficLight') {
              loader = () => import('../../forms/ServiceObject/TrafficLight/TrafficLightCard.vue')
            } else if (objectType === 'cameraFVF') {
              loader = () => import('../../forms/ServiceObject/CameraFVF/CameraFVFCard.vue')
            } else if (objectType === 'cameraTV') {
              loader = () => import('../../forms/ServiceObject/CameraTV/CameraTVCard.vue')
            } else if (objectType === 'cameraVA') {
              loader = () => import('../../forms/ServiceObject/CameraVA/CameraVACard.vue')
            } else if (objectType === 'serverEquipment') {
              loader = () => import('../../forms/ServiceObject/ServerEquipment/ServerEquipmentCard.vue')
            } else if (objectType === 'accessBoxKTO') {
              loader = () => import('../../forms/ServiceObject/AccessBoxKTO/AccessBoxKTOCard.vue')
            } else if (objectType === 'TOI') {
              loader = () => import('../../forms/ServiceObject/TOI/TOICard.vue')
            } else if (objectType === 'TEI') {
              loader = () => import('../../forms/ServiceObject/TEI/TEICard.vue')
            } else if (objectType === 'complexAudio') {
              loader = () => import('../../forms/ServiceObject/ComplexAudio/ComplexAudioCard.vue')
            } else if (objectType === 'transportDetector') {
              loader = () => import('../../forms/ServiceObject/TransportDetector/TransportDetectorCard.vue')
            } else if (objectType === 'TransportStop') {
              loader = () => import('../../forms/ServiceObject/TransportStop/TransportStopCard.vue')
            } else if (objectType === 'cameraMetro') {
              loader = () => import('../../forms/ServiceObject/MetroCamera/MetroCameraCard.vue')
            } else if (objectType === 'stationMetro') {
              loader = () => import('../../forms/ServiceObject/MetroStation/MetroStationCard.vue')
            } else if (objectType === 'vestibuleMetro') {
              loader = () => import('../../forms/ServiceObject/MetroVestibule/MetroVestibuleCard.vue')
            } else if (objectType === 'beaconMountingPoint') {
              loader = () => import('../../forms/ServiceObject/BeaconMountingPoint/BeaconMountingPointCard.vue')
            } else if (objectType === 'emergencyStandMetro' || objectType === 'tourniquetGroupMetro' || objectType === 'controlSectionMetro') {
              loader = () => import('../../forms/ServiceObject/MetroObject/MetroObjectCard.vue')
            } else if (objectType === 'stationaryPositioningDevice') {
              loader = () => import('../../forms/ServiceObject/StationaryPositioningDevice/StationaryPositioningDeviceCard.vue')
            }
          }

          if (this.component || loader) {
            this.modeCustomLocal = true
            this.loader = loader
          } else {
            this.modeCustomLocal = false
            this.loader = () => import('./ObjectCard.vue')
          }

          this.show()
        } else {
          this.hide()
        }
      },
      immediate: true
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.isWrapperMounted = true
    })
  },
  methods: {
    onCreated: function (objectId) {
      this.$emit('created', objectId)
    },
    // following methods are REQUIRED ===
    show () {
      if (this.component) {
        this.shown = true
      } else {
        this.loader()
          .then(() => {
            this.component = () => this.loader()

            this.$nextTick(() => this.shown = true)
          })
      }
    },
    hide () {
      this.shown = false
    },

    getCard () {
      return new Promise(resolve => {
        if (this.isMounted) {
          resolve(this.$refs.card)
        } else {
          const unwatch = this.$watch('isMounted', function (isMounted) {
            if (isMounted) {
              resolve(this.$refs.card)
              if (unwatch) {
                unwatch()
              }
            }
          }, {
            immediate: true
          })
        }
      })
    }
  }
}
